export enum TitleListLayout {
	GRID = 'grid',
	ROW = 'row',
	CARD = 'card',
}
